import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import useReduxSelector from 'utils/useReduxSelector';
import { FeatureFlags } from 'types';

export const isEmployeeSubTypeEnabled = (
  featureFlags?: Partial<Record<FeatureFlags, boolean>> | null,
): boolean => Boolean(featureFlags?.fixedTermEmployee) && Boolean(featureFlags?.reArchMilestone1);

export const useEmployeeSubTypeEnabled = (): boolean => {
  const featureFlags = useReduxSelector(loggedInUserSelectors.features);
  return isEmployeeSubTypeEnabled(featureFlags);
};
